/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ResourceRequest { 
    type: ResourceRequest.TypeEnum;
    filename: string;
    contentType: string;
    fileSize?: number;
}
export namespace ResourceRequest {
    export type TypeEnum = 'IMAGE' | 'VIDEO' | 'SCREENSHOT' | 'MEDIUM' | 'RECORDING';
    export const TypeEnum = {
        IMAGE: 'IMAGE' as TypeEnum,
        VIDEO: 'VIDEO' as TypeEnum,
        SCREENSHOT: 'SCREENSHOT' as TypeEnum,
        MEDIUM: 'MEDIUM' as TypeEnum,
        RECORDING: 'RECORDING' as TypeEnum
    };
}